import { Fragment } from 'react'

import { workingModeOptions, workingModeRows } from 'constants/WorkingModeSelectionConstants'

export const WorkingModeTable = () => {
  return (
    <div className="working-mode-table-scroll">
      <div className="working-mode-table">
        <div className="working-mode-label-cell working-mode-label-cell--empty" />
        {workingModeOptions.map((option, index) => (
          <div
            key={option.key}
            className={`working-mode-header-cell ${index === 0 ? 'working-mode-header-cell--first' : 'working-mode-header-cell--last'}`}
          >
            <p className="subtitle-xs color-neutral-10 uppercase">{option.badge}</p>
            <p className="title-xs color-neutral-10">{option.title}</p>
          </div>
        ))}

        {workingModeRows.map((row, rowIndex) => {
          const isFirst = rowIndex === 0
          const isLast = rowIndex === workingModeRows.length - 1
          const labelModifier = isFirst
            ? 'working-mode-label-cell--first'
            : isLast
              ? 'working-mode-label-cell--last'
              : ''
          const contentModifier = isLast ? 'working-mode-content-cell--last-row' : ''

          return (
            <Fragment key={row.label}>
              <div className={`working-mode-label-cell ${labelModifier}`}>
                <p className="subtitle-xs">{row.label}</p>
              </div>
              <div className={`working-mode-content-cell ${contentModifier}`}>
                <ul className="working-mode-bullets">
                  {row.option1.map(bullet => (
                    <li key={`${row.label}-option1-${bullet.bold ?? bullet.text}`} className="body-xs">
                      {bullet.bold && <span className="font-bold">{bullet.bold}</span>}
                      {bullet.text}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={`working-mode-content-cell ${contentModifier} ${isLast ? 'working-mode-content-cell--last-col' : ''}`}
              >
                <ul className="working-mode-bullets">
                  {row.option2.map(bullet => (
                    <li key={`${row.label}-option2-${bullet.bold ?? bullet.text}`} className="body-xs">
                      {bullet.bold && <span className="font-bold">{bullet.bold}</span>}
                      {bullet.text}
                    </li>
                  ))}
                </ul>
              </div>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}
